import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import axios from 'axios';
import BrdDashboard from './BrdDashboard';

const BUILDER_ROLES = new Set(['builder', 'realtor', 'developer']);

const OnlineBuilderOpinionEntry = () => {
  const navigate = useNavigate();
  const [access, setAccess] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (BUILDER_ROLES.has(user.role)) {
      setAccess(true);
      return;
    }
    if (user.role !== 'tenant_admin') {
      setAccess(false);
      return;
    }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/brd/context`)
      .then(() => setAccess(true))
      .catch(() => setAccess(false));
  }, []);

  if (access === null) return <main className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="online-builder-access-loader"><span className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-blue-700" /></main>;
  if (access) return <BrdDashboard />;

  return <main className="min-h-screen bg-slate-50 px-4 py-8 sm:px-8 sm:py-12" data-testid="online-builder-read-only-entry">
    <div className="mx-auto max-w-3xl">
      <button type="button" onClick={() => navigate('/dashboard')} className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 transition-colors hover:text-slate-950" data-testid="online-builder-entry-back-button"><ArrowLeft className="h-4 w-4" />Back to dashboard</button>
      <section className="mt-10 border border-slate-200 bg-white p-6 sm:p-10" data-testid="online-builder-access-notice">
        <ShieldAlert className="h-7 w-7 text-blue-700" aria-hidden="true" />
        <p className="mt-6 text-sm font-semibold uppercase tracking-[0.12em] text-blue-700">Applications</p>
        <h1 className="mt-2 text-4xl font-semibold text-slate-950" data-testid="online-builder-access-title">Online Builder Opinion</h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-slate-600" data-testid="online-builder-access-message">Builder Dashboard access is available to authorized Builder, Realtor, Developer, and BRD tenant accounts. Your current account keeps its existing permissions.</p>
      </section>
    </div>
  </main>;
};

export default OnlineBuilderOpinionEntry;